import Breadcrumbs from '@/components/modules/breadcrumbs/Breadcrumbs';
import { classnames } from '@/helpers';
import useMobileView from '@/hooks/useMobileView';
import { ReactNode } from 'react';

type SerpHeaderProps = {
  breadcrumbs: { title: string; url: string }[];
  heading: ReactNode;
  seoText: string;
  image?: { src: string; height: number; width?: number };
};

const SerpHeader = ({ breadcrumbs, heading, seoText, image }: SerpHeaderProps) => {
  const { isMobileView } = useMobileView();

  return (
    <header className="pb-md relative md:pb-0" style={{ minHeight: image?.height }}>
      <div className="space-y-2xl">
        <div style={{ height: 36 }} className="grid items-center">
          <Breadcrumbs items={breadcrumbs} />
        </div>
        <div className={classnames('space-y-md md:space-y-xl', image && 'md:pr-xl md:w-4/5')}>
          <span className="gap-md relative inline-flex h-max w-full items-center justify-between">
            <h1 className="text-h-m md:text-h-xl">{heading}</h1>
            {isMobileView && image && (
              <img src={image.src} style={{ width: image.width ?? 'auto', height: image.height }} />
            )}
          </span>
          <p className="text-fg_secondary text-l">{seoText}</p>
        </div>
      </div>

      {!isMobileView && image && (
        <div className="pointer-events-auto absolute right-0 top-1/2 grid h-full -translate-y-1/2 select-none place-items-center">
          <img src={image.src} style={{ width: image.width ?? 'auto', height: image.height }} />
        </div>
      )}
    </header>
  );
};

export default SerpHeader;
